'use es6';

import CookiesByCategory from './CookiesByCategory';
import { COOKIES_BY_CATEGORY, OPT_IN, SETTINGS_PRIVACY_POLICIES } from 'cookie-banner/constants/privacyPolicy';
export default class PrivacySettings {
  constructor(policy, policyTesting) {
    this.active = policy.enabled;
    this.testing = policyTesting;
    this.mode = SETTINGS_PRIVACY_POLICIES[policy.privacyPolicy];
    this.policyWording = policy.privacyPolicyWording;
    this.acceptWording = policy.privacyAcceptWording;
    this.cancelWording = policy.privacyDismissWording;
    this.disclaimerWording = policy.privacyDisclaimerWording;
    this.hideDecline = policy.privacyHideDecline || false;
    this.accentColor = policy.privacyBannerAccentColor || null;
    this.bannerType = policy.privacyBannerType || null;
    this.label = policy.privacyDefault ? 'default' : policy.label;
    this.cookiesByCategory = CookiesByCategory.build(policy.cookiesByCategory);
    this.id = policy.id;
    this.portalId = policy.portalId;
    this.showCloseButton = policy.showCloseButton;
  }
  isOptInPolicy() {
    return this.active && this.hideDecline === false && (this.mode === COOKIES_BY_CATEGORY || this.mode === OPT_IN);
  }
}